var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row login-white-wrap whiteBG-wrap"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('LoginCarsoule')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap d-flex align-items-center justify-content-center flex-column text-center"
  }, [_c('div', {
    staticClass: "spinner-border text-primary mb-3",
    attrs: {
      "role": "status"
    }
  }), _c('h4', [_vm._v("Logging you in...")]), _c('p', [_vm._v("Please wait while we log you in securely.")])])]);

}]

export { render, staticRenderFns }